export const DEFAULT_STALE_TIME = 2 * 1000
export const THIRTY_SECONDS_STALE_TIME = 30 * 1000
export const TEN_MINUTES_STALE_TIME = 10 * 60 * 1000
export const ONE_HOUR_STALE_TIME = 60 * 60 * 1000

export const DEFAULT_CACHE_TIME = 10 * 60 * 1000
